<template>
  <div class="booking-widget">
    <v-form class="booking-widget_form" ref="bookingForm">
      <div class="booking-widget_fields">
        <div class="booking-widget_fields-inner">
          <div class="booking-widget_field booking-widget_field--dates">
            <span class="booking-widget_field-label">Дата заезда-выезда</span>
            <v-menu
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              v-model="dateMenu"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Дата заезда"
                  readonly
                  v-on="on"
                  solo
                  class="ui-input"
                  hide-details
                  :value="dispDates"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>$calendar</v-icon>
                  </template>
                </v-text-field>
              </template>

              <v-date-picker
                class="ui-datepicker"
                width="auto"
                locale="ru-ru"
                v-model="dates"
                no-title
                range
                :min="(new Date()).toISOString()"
                @change="onDatepickerChange"
                :first-day-of-week="calStartDay"
                :weekday-format="getWeekDay"
              ></v-date-picker>
            </v-menu>
          </div>

          <div class="booking-widget_field booking-widget_field--days">
            <span class="booking-widget_field-label">Количество дней</span>
            <v-text-field
              solo
              v-model="daysCnt"
              @keydown="checkKey($event, /[\d]/)"
              @change="onDaysCntChange"
              class="ui-input"
              hide-details
              :rules="[validationRules.required]"
            ></v-text-field>
          </div>

          <div class="booking-widget_field booking-widget_field--guests">
            <span class="booking-widget_field-label">Количество гостей</span>
            <guests-field
              :data="guests"
              @update="onGuestsUpdate"
            />
          </div>

          <div class="booking-widget_field booking-widget_field--buy-mode">
            <span class="booking-widget_field-label">
              &nbsp;
            </span>
            <div class="booking-widget_field-input-wrapper">
              <label for="#" class="booking-widget_field-switch-label"
                     @click="setIsPresent(false)"
                    :class="isPresent ? '' : 'booking-widget_field-switch-label--choose'">
                Я покупаю
              </label>
              <image-switch v-model="isPresent"
                            falseImg=""
                            trueImg=""
                            width="6rem"
                            height="var(--image-switch-height-mobile, var(--image-switch-height-base, auto))"
                            trueMarkerImgSize="70%"
                            :falseMarkerImg="require('@/assets/img/buy.svg')"
                            :trueMarkerImg="require('@/assets/img/gift.svg')"
                            falseMarkerColor="var(--prime-color)"
                            falseBGColor="#fff"
                            trueBGColor="linear-gradient(94.11deg, #FC9C97 7.37%, #FFAC7E 100%)">
              </image-switch>
              <label for="#" class="booking-widget_field-switch-label"
                     @click="setIsPresent(true)"
                     :class="isPresent ? 'booking-widget_field-switch-label--choose' : ''">
                Я дарю
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="booking-widget_actions">
        <a
          href="javascript:void(0)"
          class="booking-widget_action"
          @click.prevent="onSubmit"
        >
          Найти номер
        </a>
      </div>
    </v-form>
  </div>


</template>

<script>
import ImageSwitch from "@/components/ui/ImageSwitch.vue";
import GuestsField from "./GuestsField.vue";

export default {
  components: {
    ImageSwitch,
    GuestsField,
  },

  data: () => {
    return {
      defaultDaysCnt: 10,
      spaTour: false,
      settingsSpaTour: [],
      dateIn: null,
      dateOut: null,
      dates: [],
      daysCnt: null,
      minDays: 1,
      maxDays: 30,
      guestsValue: '1',
      validationRules: {
        required: value => !!value || 'Обязательно к заполнению.',
      },
      dateMenu: false,
      isPresent: false,
      guests: [],
    }
  },

  computed: {
    calStartDay() {
      return process.env.VUE_APP_SEARCH_CAL_START_DAY || 0
    },

    dispDates() {
      let start
      let end
      let str = ''

      if(this.dateIn) {
        start = this.dateIn.split('-')
        str = `${start[2]}.${start[1]}.${start[0]}`
      }

      if(this.dateOut) {
        end = this.dateOut.split('-')
        str += ` - ${end[2]}.${end[1]}.${end[0]}`
      }

      return str
    },
  },

  methods: {
    getWeekDay(date) {
      return new Date(date).toLocaleString('ru-RU', { weekday: 'short' })
    },
    setIsPresent(value) {
      this.isPresent = value;
    },
    onDatepickerChange(arr) {
      const sortedArr = this.sortDates(arr);
      const daysCnt = this.calculateDaysDiff(sortedArr[0], sortedArr[1]);

      this.dateIn = sortedArr[0];

      const { dateOut, calculatedDaysCnt } = this.calculateAdjustedDates(
        daysCnt,
        sortedArr[0],
        sortedArr[1]
      );

      this.dateOut = dateOut;
      this.daysCnt = calculatedDaysCnt;
      this.dates = [this.dateIn, this.dateOut];
      this.dateMenu = false;
    },

    onDaysCntChange(val) {
      let daysCnt = +val;
      const dateInObj = new Date(this.dateIn);


      daysCnt = this.adjustDaysCount(daysCnt);

      this.daysCnt = daysCnt;
      this.dateOut = this.calculateDateOut(dateInObj, (daysCnt + 1));
      this.dates = [this.dateIn, this.dateOut];
    },

    sortDates(arr) {
      return arr.slice().sort((a, b) => new Date(a) - new Date(b));
    },

    calculateDaysDiff(date1, date2) {
      return (new Date(date2) - new Date(date1)) / 1000 / 60 / 60 / 24;
    },

    calculateDateOut(dateInObj, daysCnt) {
      return new Date(
        dateInObj.getFullYear(),
        dateInObj.getMonth(),
        dateInObj.getDate() + daysCnt
      ).toISOString().substring(0, 10);
    },

    isSpaTourExceptionAllowed(dateIn) {
      const now = new Date();
      const daysThreshold = this.calculateSpaTourThreshold();
      const twoWeeksFromNow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + daysThreshold);
      return this.spaTour && new Date(dateIn) < twoWeeksFromNow;
    },

    calculateSpaTourThreshold() {
      const defaultThreshold = 14;

      if (!this.settingsSpaTour || !this.settingsSpaTour['kluchi']) {
        return defaultThreshold;
      }

      const settings = this.settingsSpaTour['kluchi'];

      if (settings.openBefore) {
        const now = new Date();
        const openBeforeDate = new Date(settings.openBefore);
        const daysDiff = Math.ceil((openBeforeDate - now) / (1000 * 60 * 60 * 24));
        const result = Math.max(0, daysDiff);
        if (isNaN(result)) {
          console.log('error:ошибка преобразования дат из settings.openBefore');
          return defaultThreshold;
        } else {
          return result;
        }
      }


      if (settings.bookingPeriod) {
        return +settings.bookingPeriod;
      }

      return defaultThreshold;
    },

    adjustSpaTourDays(daysCnt) {
      switch(daysCnt) {
        case 1:
          return 2;
        case 4:
          return 5;
        case 6:
          return 7;
        default:
          return daysCnt;
      }
    },

    adjustDaysCount(daysCnt) {
      if (daysCnt < +this.minDays) {
        if (this.isSpaTourExceptionAllowed(this.dateIn)) {
          return this.adjustSpaTourDays(daysCnt);
        } else {
          return +this.minDays;
        }
      } else if (daysCnt > this.maxDays) {
        return this.maxDays;
      }
      return daysCnt;
    },

    calculateAdjustedDates(daysCnt, dateIn, dateOut) {
      if (daysCnt < this.minDays) {
        if (this.isSpaTourExceptionAllowed(dateIn)) {
          const adjustedDaysCnt = this.adjustSpaTourDays(daysCnt);
          let adjustedDateOut;
          if ([2,5,7].includes(adjustedDaysCnt)) {
            adjustedDateOut = this.calculateDateOut(new Date(dateOut), adjustedDaysCnt - daysCnt);
          } else {
            adjustedDateOut = dateOut;
          }
          return { dateOut: adjustedDateOut, calculatedDaysCnt: adjustedDaysCnt };
        } else {
          const adjustedDateOut = this.calculateDateOut(new Date(dateIn), +this.minDays);
          return { dateOut: adjustedDateOut, calculatedDaysCnt: +this.minDays };
        }
      } else if (daysCnt > this.maxDays) {
        const adjustedDateOut = this.calculateDateOut(new Date(dateIn), +this.maxDays);
        return { dateOut: adjustedDateOut, calculatedDaysCnt: +this.maxDays };
      } else {
        return { dateOut, calculatedDaysCnt: daysCnt };
      }
    },

    checkKey(e, pattern) {
      const allowedKeys = [8, 9, 13, 16, 17, 18, 27, 32, 37, 38, 39, 40]
      let keyCode = e.which || e.keyCode
      let keyValue = e.key

      if(
        allowedKeys.indexOf(keyCode) === -1
        && !pattern.test(keyValue)
      ) {
        e.preventDefault()
      }
    },

    onSubmit() {
      if(this.$refs.bookingForm.validate()) {
        let url = `/booking?`

        let params = {
          dateIn: this.dateIn,
          dateOut: this.dateOut,
          daysCnt: this.daysCnt,
          // cnt: +this.guestsValue,
          isPresent: this.isPresent,
          ...this.guests.reduce((acc, cur) => {
            acc[cur.alias] = cur.value
            return acc
          }, {})
        }

        const paramStr = new URLSearchParams(params).toString()

        document.location.href = `${url}${paramStr}`
      }
    },

    onGuestsUpdate(obj) {
      const index = this.guests.findIndex(i => i.id === obj.id)
      this.guests[index].value = obj.value
    }
  },

  async created() {
    let rawResp = await this.$http.get('/dictionary/')

    let resp = rawResp.data.data
    console.log('resp=',resp)

    this.spaTour = resp.spaTour || false
    this.minDays = resp.daysMin;

    this.settingsSpaTour = resp.settingsSpaTour || [];


    console.log('this.settingsSpaTour=',this.settingsSpaTour)
    let dateIn = null
    let dateOut = null
    this.daysCnt = this.defaultDaysCnt
    dateIn = new Date().toISOString().substring(0, 10)
    this.dateIn = dateIn

    let dateInObj = new Date(Date.parse(dateIn))
    dateOut = new Date(
      dateInObj.getFullYear(),
      dateInObj.getMonth(),
      dateInObj.getDate() + this.daysCnt + 1
    )
      .toISOString()
      .substring(0, 10)
    this.dateOut = dateOut

    // массив дат для календаря
    this.dates = [dateIn, dateOut]

    // кол-во гостей
    this.guests = resp.ageGroup.map(obj => {
      const alias = {
        '0': 'guestAdultCount',
        '1': 'guestChildCount',
        '2': 'guestBabyCount',
      }
      const subtitles = {
        '0': '14 лет и старше',
        '1': 'от 4-х до 13 лет',
        '2': 'до 3-х лет',
      }
      return {
        ...obj,
        id: String(obj.id),
        value: obj.default ? 1 : 0,
        min: obj.default ? 1 : 0,
        alias: alias[obj.id],
        title: String(obj.id) === '0' ? 'Взрослые' : 'Дети',
        subtitle: subtitles[obj.id],
      }
    })
  },
}
</script>

<style lang="sass" scoped>
.booking-widget
  width: 100%
  font-size: 1em
  // background-color: rgba(36, 137, 131, 1)
  background-color: $primary-color
  color: #fff

.booking-widget_form
  display: flex
  align-items: flex-end
  width: 100%
  max-width: 1464px
  margin: 0 auto
  padding: p2e(16) p2e(30)
  // outline: 1px solid red

.booking-widget_fields
  min-width: 1px
  flex-grow: 1

.booking-widget_fields-inner
  width: calc(100% + p2e(20))
  margin-left: p2e(-10)
  margin-right: p2e(-10)
  display: flex
  align-items: center

.booking-widget_field
  width: 25%
  padding: 0 p2e(10)

  &--dates
    width: 50%


.booking-widget_actions
  margin-left: p2e(20)

.booking-widget_action
  display: block
  padding: p2e(11) p2e(46)
  border-radius: p2e(50)
  color: #000
  text-decoration: none
  background-color: #FFEB78
  text-align: center

.booking-widget_field--buy-mode
  align-self: stretch
  display: flex
  flex-direction: column

.booking-widget_field-input-wrapper
  --image-switch-height-base: 100%
  flex: 1
  display: flex
  flex-direction: row
  align-items: center
  column-gap: 10px

.booking-widget_field-switch-label
  text-wrap: nowrap
  cursor: pointer
  color: #fbeaea

.booking-widget_field-switch-label--choose
  color: #fff
  font-weight: bold

@media screen and (max-width: $wide-screen-breakpoint)
  .booking-widget_field
    &--dates
      width: 45%

    &--buy-mode
      width: 30%

  .booking-widget_field-label
    font-size: 12px
    white-space: nowrap

  .booking-widget_field-input-wrapper
    --image-switch-height-mobile: 80%

  .booking-widget_field-switch-label
    font-size: 12px

  .booking-widget_action
    font-size: 12px

@media screen and (max-width: $mobile-breakpoint)
  .booking-widget_field
    &--buy-mode
      .booking-widget_field-label
        display: none

  .booking-widget_action
    font-size: initial

  .booking-widget_field-label
    font-size: initial

  .booking-widget_form
    flex-direction: column
    padding: p2e(15, 12) p2e(20, 12)

  .booking-widget_fields
    width: 100%

  .booking-widget_fields-inner
    flex-direction: column

  .booking-widget_field
    width: 100%

    + .booking-widget_field
      margin-top: p2e(20, 12)

  .booking-widget_actions
    margin-left: 0
    margin-top: p2e(20, 12)
    width: 100%
    min-height: p2e(44,12)

  .booking-widget_field-input-wrapper
    --image-switch-height-mobile: 3.6666666667em
    min-height: 3em
    justify-content: center
    align-items: stretch

  .booking-widget_field-switch-label
    font-size: medium
    margin: auto 0
</style>
